import { FC } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import {
  Sidebar,
  useRightSidebarContent,
} from "@capacit-com/lara-law-shared-ui";

/**
 * Renders the right-sidebar node the active page stored in `RightSidebarContentProvider`.
 *
 * Mounted outside `<Routes>`, and therefore outside every `AuthenticationGuard`, so it is
 * gated on `isAuthenticated`: page sidebars depend on providers that only exist while
 * authenticated (`ConversationSidebar` → `useConversationHub`), and rendering one on an
 * unauthenticated shell used to take the whole app down on an Auth0 session flip.
 * `PageContent` clears the stored content when it unmounts; this gate is the backstop for
 * any window where it has not yet.
 */
const RightSidebarRenderer: FC = () => {
  const { isAuthenticated } = useAuth0();
  const { content } = useRightSidebarContent();

  if (!isAuthenticated || !content) return null;

  return <Sidebar side="right">{content}</Sidebar>;
};

export default RightSidebarRenderer;
